import api from './axios';
import { ApiResponse, Cart } from '../types';

export const cartAPI = {
  getCart: async () => {
    const res = await api.get<ApiResponse<Cart>>('/api/cart');
    return res.data;
  },

  addToCart: async (data: {
    product_id: string;
    variant_id: string;
    quantity: number;
    measurements?: Record<string, string | undefined>;
  }) => {
    const res = await api.post<ApiResponse<{}>>('/api/cart', data);
    return res.data;
  },

  updateCartItem: async (id: string, quantity: number) => {
    const res = await api.put<ApiResponse<{}>>(`/api/cart/${id}`, { quantity });
    return res.data;
  },

  removeFromCart: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/cart/${id}`);
    return res.data;
  },

  clearCart: async () => {
    const res = await api.delete<ApiResponse<{}>>('/api/cart/clear');
    return res.data;
  },
};